import { AnswerTemplate } from "../../../model/templates/AnswerTemplate";
import { AnswerTemplateDtoIn } from "../../../generated";
import { fromSeverityStatusToGenerated } from "../parseSeverityStatus";

export const fromAnswerTemplateToGenerated = (data: AnswerTemplate): AnswerTemplateDtoIn => ({
  text: data.text,
  severity: fromSeverityStatusToGenerated(data.severity),
  alertNote: data.alertNote,
});
